import React, {FC, useState} from 'react';

import {useMyTask} from './useMyTask';
import {ModalWithHeader} from '../../common/ModalWithHeader';
import {EnhancedDetailsList} from '../../common/EnhancedDetailsList';
import {Pivot, PivotItem, Spinner} from '@fluentui/react';
import {MyTask} from '../../../models/MyTask';
import {TheButton} from '../../common/TheButton';
import styles from './MyTask.module.scss';
import {MyAcknowledgement} from '../MyAcknowledgement';

interface IMyTaskModal {
  isOpenModal: boolean;
  closeModal: () => void;
}

export const MyTaskModal: FC<IMyTaskModal> = ({isOpenModal, closeModal}) => {
  const {
    columnProcessExpired,
    columnsDocumentExpired,
    columnsDocumentsAwaitngApproval,
    columnUnresolvedFeedback,
    processExpiredResult,
    documentExpiredResult,
    documentAwaitingApprovalResult,
    unresolvedFeedbackResult,
    isProcessExpiredLoading,
    isDocumentExpiredLoading,
    isDocumentAwaitingApprovalLoading,
    isInitiatedAcknowledgementsLoading,
    isReceivedAcknowledgementsLoading,
    initiatedAcknowledgements,
    receivedAcknowledgements,
    userHasAccessToAdditionalTabs,
    isUnresolvedFeedbackLoading
  } = useMyTask(isOpenModal);

  const [selectedKey, setSelectedKey] = useState<string>('expiredProcesses');

  const handleLinkClick = (item?: PivotItem) => {
    if (item) {
      setSelectedKey(item.props.itemKey!);
    }
  };

  return (
    <ModalWithHeader
      isBlocking={false}
      header="My Pending Tasks"
      isVisible={isOpenModal}
      dismiss={() => closeModal()}>
      {(processExpiredResult ||
        documentExpiredResult ||
        documentAwaitingApprovalResult ||
        unresolvedFeedbackResult) && (
        <Pivot selectedKey={selectedKey} onLinkClick={handleLinkClick}>
          <PivotItem headerText="Expired Processes" itemKey="expiredProcesses">
            {isProcessExpiredLoading ? (
              <Spinner />
            ) : (
              <EnhancedDetailsList<MyTask, MyTask, MyTask>
                items={processExpiredResult}
                columns={columnProcessExpired}
                hideSearch
                pageSize={10}
              />
            )}
          </PivotItem>
          <PivotItem headerText="Expired Documents" itemKey="expiredDocuments">
            {isDocumentExpiredLoading ? (
              <Spinner />
            ) : (
              <EnhancedDetailsList<MyTask, MyTask, MyTask>
                items={documentExpiredResult}
                columns={columnsDocumentExpired}
                hideSearch
                pageSize={10}
              />
            )}
          </PivotItem>
          <PivotItem headerText="Documents Awaiting Approval" itemKey="documentsAwaitingApproval">
            {isDocumentAwaitingApprovalLoading ? (
              <Spinner />
            ) : (
              <EnhancedDetailsList<MyTask, MyTask, MyTask>
                items={documentAwaitingApprovalResult}
                columns={columnsDocumentsAwaitngApproval}
                hideSearch
                pageSize={10}
              />
            )}
          </PivotItem>
          {userHasAccessToAdditionalTabs && (
            <PivotItem headerText="Unresolved Feedbacks" itemKey="unresolvedFeedbacks">
              {isUnresolvedFeedbackLoading ? (
                <Spinner />
              ) : (
                <EnhancedDetailsList<MyTask, MyTask, MyTask>
                  items={unresolvedFeedbackResult}
                  columns={columnUnresolvedFeedback}
                  hideSearch
                  pageSize={10}
                />
              )}
            </PivotItem>
          )}
          {userHasAccessToAdditionalTabs && (
            <PivotItem headerText="Initiated Acknowledgements" itemKey="initiatedAcknowledgements">
              {isInitiatedAcknowledgementsLoading ? (
                <Spinner />
              ) : (
                <MyAcknowledgement
                  pageSize={10}
                  isInitiatedView
                  elements={initiatedAcknowledgements}
                />
              )}
            </PivotItem>
          )}
          <PivotItem headerText="Received Acknowledgements" itemKey="receivedAcknowledgements">
            {isReceivedAcknowledgementsLoading ? (
              <Spinner />
            ) : (
              <MyAcknowledgement 
              pageSize={10} 
              elements={receivedAcknowledgements} />
            )}
          </PivotItem>
        </Pivot>
      )}
      <div className={styles.buttons}>
        <TheButton primary onClick={() => closeModal()}>
          Close
        </TheButton>
      </div>
    </ModalWithHeader>
  );
};
